import { useDispatch, useSelector } from "react-redux"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { SystemDescriptions } from "src/common/descriptions"
import { PageCard } from "src/common/styles/styles"
import { SearchableTable } from "src/components/SearchableTable"
import { RootState } from "src/state/reducer"
import { summaryColumns, TABLE_COLUMNS } from "./config"
import { ColumnsType } from "antd/es/table"
import moment from "moment"
import dayjs from 'dayjs'
import { useEffect, useState } from "react"
import { DateRanges } from "src/components/SearchableTable/types"
import { SystemConstants } from "src/common/constants"
import { Urls } from "src/common/urls"
import { useNavigate } from "react-router"
import { Button } from "antd"
import useUserPermission from "src/hooks/useUserPermissions"
import { USER_SCOPES } from "src/hooks/UserPermission"
import { getIncomeRecordsApi } from "src/features/CashboxStatement/state/action"
import { IncomeRecord } from "src/common/models/incomeRecord"
import { GET_INCOME_RECORDS_API } from "src/features/CashboxStatement/state/actionTypes"

export type ReduxProps = {
    incomeRecords?: IncomeRecord[],
    isGettingRecords: boolean
}

export const IncomeRecords = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { validateUserScopeForPage } = useUserPermission()

    const [dateRanges, setDateRanges] = useState<DateRanges>({
        startDate: moment().startOf('month').format(SystemConstants.DATETIME_QUERY(true)),
        endDate: moment().format(SystemConstants.DATETIME_QUERY(false)),
    })

    const handleDateRangesChange = (dateRanges: DateRanges) => {
        setDateRanges({
            startDate: moment(dateRanges.startDate).format(SystemConstants.DATETIME_QUERY(true)),
            endDate: moment(dateRanges.endDate).format(SystemConstants.DATETIME_QUERY(false)),
        })
    }

    const fetchRecords = () => {
        dispatch(getIncomeRecordsApi({
            dateFrom: dateRanges.startDate,
            dateTo: dateRanges.endDate,
        }))
    }

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.EXPENDITURE_RECORD_READ)
        fetchRecords()
    }, [])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        incomeRecords: state.cashbox.incomeRecords || [],
        isGettingRecords: serviceLoading(state, [GET_INCOME_RECORDS_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.ACCOUNT_PAYABLES.EXPENDITURE_RECORDS

    const tblColumns: ColumnsType<IncomeRecord> = [
        ...TABLE_COLUMNS,
    ]

    const handleActionButtonClick = () => {
        fetchRecords()
    }

    const handleExtraAction = () => {
        navigate(Urls.FRONTEND.EXPENDITURE_RECORD.CREATE)
    }

    const renderExtraContent = () => (
        <Button
            color="default"
            size="small"
            onClick={handleExtraAction}
        >
            {descriptions.CREATE}
        </Button>
    )

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
            extra={renderExtraContent()}
        >
            <SearchableTable
                showSearch
                showLoader={reduxProps.isGettingRecords}
                items={reduxProps.incomeRecords || []}
                tableColumns={tblColumns as any}
                searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
                summaryColumns={summaryColumns}
                showRangePicker
                rangePickerOnChange={handleDateRangesChange}
                rangePickerDefaultValues={[
                    dayjs().startOf('month'),
                    dayjs()
                ]}
                actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                showActionButton
                actionButtonOnClick={handleActionButtonClick}
            />
        </PageCard>
    )
}
